<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" center :title="dialogTitle">
      <div class="default-table" style="margin: 10px">
        <el-table :data="dataList" :loading="loading"
                  :summary-method="getSummaries"
                  show-summary
                  border>
          <el-table-column label="序号" width="65" align="center">
            <template slot-scope="{$index}">{{ $index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="order_no" label="订单编号" align="center"></el-table-column>
          <el-table-column prop="payment_account" label="含税收入" header-align="center" align="right"></el-table-column>
          <el-table-column prop="project_name" label="项目名称" align="center"></el-table-column>
          <el-table-column prop="form_of_cooperation" label="合作形式" align="center"></el-table-column>
          <el-table-column prop="created_at" label="创建时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{row}">
              <el-link type="danger" icon="el-icon-remove" @click="handleDelete(row)"></el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-form ref="elForm" :model="formData" :rules="rules" inline label-width="80px">
        <el-form-item label="项目名称" prop="project_name">
          <el-input v-model="formData.project_name" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="onSubmit" v-if="userAuth.order_merge_project">确认合并</el-button>
        <el-button @click="close">取消</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import {preMergeOrders, saveMergeOrders} from "@/api/order";

export default {
  name: "MergeOrder",
  props: {
    orderIds: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        order_ids: [],
        project_name: ''
      },
      rules: {
        project_name: {required: true, message: '全案营销的项目名称必填', trigger: 'blur'}
      },
      dataList: [],
      calcFields: ['payment_account'],
    }
  },
  computed: {
    dialogTitle() {
      return `全案营销订单合并到同一个项目`
    },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    onOpen() {
      this.getOrderInfo()
    },
    onClose() {
      this.$refs['elForm'].resetFields()
    },
    close() {
      this.$emit('update:visible', false)
    },
    async getOrderInfo() {
      this.loading = true
      let params = {ids: this.orderIds}
      let {list} = await preMergeOrders(params).then((res) => {
        return res.model
      })
      this.loading = false
      this.dataList = list
      if (list && list[0]) {
        this.formData.project_name = list[0]['project_name'] || ''
      }
      // this.formData.order_ids = this.orderIds
      // console.log(params);
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        // if (index < 1) {
        //   return
        // }
        if (index === 0) {
          sums[index] = '汇总:'
          return
        }
        if (this.calcFields.indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          sums[index] = this.moneyFormat(sums[index])

          // switch (column.property) {
          //   case 'exec_price':
          //   case 'authorized_price':
          //   case 'company_income':
          //   case 'artist_income':
          //   case 'sum_amount':
          //   case 'payment_account':
          //   case 'adv_revenue':
          //   case 'cart_charges':
          //   case 'cart_commission':
          //     sums[index] = this.moneyFormat(sums[index])
          //     break
          //   default:
          //     break
          // }
        }
      })

      return sums
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2, ',')
    },
    onSubmit() {
      this.$refs["elForm"].validate(valid => {
        if (valid) {
          let ids = this.dataList.map((item) => {
            return item.id
          })
          if (!ids || ids.length === 0) {
            this.$notify.warning('请先选择要合并的订单');
            return
          }
          let postData = {ids: ids, project_name: this.formData.project_name}
          this.$msgbox.confirm(`此操作将合并当前预览的订单（共计${ids.length}单）到同一个全案营销项目[${this.formData.project_name}], 是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            saveMergeOrders(postData).then((res) => {
              return res.model
            })
            this.close()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消合并'
            });
          });
        }
      });

    },
    handleDelete(row) {
      let index = this.dataList.findIndex(value => value.id === row.id)
      this.dataList.splice(index, 1)
    }
  }
}
</script>

<style scoped>

</style>